export const splitLanguage = (lang: string): string =>
  lang.split('-')[0].toLowerCase();
